const translations = {
    'forest.ageBucket': '- age %d: %d',
    'forest.noTrees': 'No trees.',
    'forest.section': 'Forest overview',
    'forest.treesByAge': 'Trees by age',
    'forest.treesTotal': 'Trees total: %d',
};

export default translations;
